import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { Helmet } from 'react-helmet-async';
import { isDeviationPixelArt, isFileLargerThanSize, } from '../../../DeviationViews/_helpers';
import { getSrcSet } from '../../../DeviationViews/Dumbo/Image/_helpers';
import MediaService from '../../../utils/DeviationMediaService';
import useDeviationDrag from '../../../Dnd/useDeviationDrag';
import ContentShadow from '../_partials/ContentShadow';
import ImageContent from './ImageContent';
import ZoomModal from './ZoomModal';
import { useDeviationViewContext } from '../../../Context';
import s from './Image.scss';
export var ImageFullView = function (_a) {
    var _b;
    var width = _a.width, height = _a.height, deviation = _a.deviation, isZoomed = _a.isZoomed, onEnterZoomMode = _a.onEnterZoomMode, onExitZoomMode = _a.onExitZoomMode;
    var isFullscreen = useDeviationViewContext().isFullscreen;
    var isPixel = isDeviationPixelArt(deviation);
    var _c = useDeviationDrag({
        deviation: deviation,
    }), dragPreview = _c.dragPreview, drag = _c.drag;
    var zoomedFile = MediaService.getLargestFullview(deviation);
    var isHuge = !!zoomedFile && // must have a fullview
        !MediaService.isGif(deviation) && // must not be a gif as selecting sized one will give you static jpg sometimes
        isFileLargerThanSize(zoomedFile, width, height); // must be larger than the artstage
    var file = isHuge
        ? MediaService.getFullviewForSize(deviation, isZoomed ? 0 : width, isZoomed ? 0 : height)
        : zoomedFile;
    if (!file) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], isFullscreen && s['fullscreen']), style: { width: width, height: height } },
        React.createElement(Helmet, null,
            React.createElement("link", __assign({ rel: "preload", href: file.src, as: "image" }, { fetchpriority: 'high' }))),
        isZoomed && zoomedFile && (React.createElement(ZoomModal, { src: zoomedFile.src, srcSet: getSrcSet(deviation), width: zoomedFile.width, height: zoomedFile.height, isPixel: isPixel, onClose: onExitZoomMode })),
        React.createElement(ContentShadow, { content: file, containerSize: { width: width, height: height }, useSmallStage: true, className: s['shadow'] },
            React.createElement("div", { ref: drag },
                React.createElement(ImageContent, { key: file.src, width: width, height: height, file: file, alt: (_b = deviation.title) !== null && _b !== void 0 ? _b : '', isPixel: isPixel, canZoom: isHuge, onZoom: onEnterZoomMode }))),
        dragPreview));
};
ImageFullView.displayName = 'ImageFullView';
export default ImageFullView;
//# sourceMappingURL=Image.js.map